<template>
	<ul class="list_cafe">
		<template v-for="(article, index) in articles">
			<li :class="getLiClass(article)">
				<a class="link_cafe make-list-uri" href="javascript:" @click="goToArticle(article)">
					<img class="article_thumb" :src="article.thumbnailImageUrl" alt="" v-if="article.thumbnailImageUrl">
					<span class="article_info">
					<strong class="tit_info">
						<span class="txt_detail" v-html="article.title"></span>
						<span class="ico_cafe ico_play" v-if="article.hasMovie">동영상</span>
						<span class="ico_new" v-if="article.newArticle">
							<span class="sr_only">new</span>
							<img src="//t1.daumcdn.net/cafe_image/mobile/svg/15_new.svg" width="15" height="15" alt=""/>
						</span>
					</strong>
					<span class="txt_info">
						<span class="sr_only">게시판명</span>
						<span class="board_name">{{ ellipsisText(unescapeBackslash(article.fldName), 20) }}</span>
						<template v-if="article.writerNickname">
							<span class="sr_only">작성자</span>
							<span class="username">{{ ellipsisText(article.writerNickname, 7) }}</span>
						</template>
						<span class="sr_only">작성시간</span>
						<span class="created_at">{{ article.articleElapsedTime }}</span>
						<span class="sr_only">조회수</span>
						<span class="view_count">{{ formatNumber(article.viewCount) }}</span>
					</span>
				</span>
				</a>
				<a class="link_cmt make-list-uri make-return-uri" href="javascript:" @click="goToComment(article)" v-if="article.commentCount > 0">
					<span class="sr_only">댓글수</span>
					<span class="num_cmt">{{ article.commentCount }}</span>
				</a>
			</li>
			<BannerAd v-if="bannerAdUnitId && isBannerIndex(index)" :bannerAdUnitId="bannerAdUnitId" :index="index"/>
		</template>
		<div ref="bottomEl"/>
	</ul>
</template>

<script>
import axios from 'axios';
import BannerAd from './BannerAd.vue';

export default {
	components: {BannerAd},
	props: ['grpId', 'grpCode', 'pageSize', 'initialArticles', 'bannerAdUnitId'],
	data() {
		return {
			articles: [...this.initialArticles],
			hasMore: true,
			loading: false,
		};
	},
	computed: {
		afterFldId() {
			if (this.articles.length === 0) {
				return null;
			}

			return this.articles[this.articles.length - 1].fldid;
		},
		afterDataId() {
			if (this.articles.length === 0) {
				return null;
			}

			return this.articles[this.articles.length - 1].dataid;
		},
		afterRegDt() {
			if (this.articles.length === 0) {
				return null;
			}

			return this.articles[this.articles.length - 1].regDt;
		},
		stateStorageKey() {
			return `RECENT_ARTICLES_STATE:${this.grpId}`;
		},
	},
	methods: {
		getLiClass(article) {
			return {
				my_on: article.articleWriter,
				cmt_on: article.commentCount > 0,
				thumbnail_on: !!article.thumbnailImageUrl,
			};
		},
		makeArticleLinkUrl(article) {
			const {fldid, dataid, hasParentArticle} = article;
			const query = hasParentArticle ? `qaanswerid=${dataid}` : '';

			return `/${this.grpCode}/${fldid}/${dataid}?${query}`;
		},
		makeArticleCommentLinkUrl(article) {
			const {fldid, dataid, hasParentArticle} = article;
			const query = hasParentArticle ? `qaanswerid=${dataid}` : '';

			return `/${this.grpCode}/${fldid}/${dataid}/comments?${query}`;
		},
		ellipsisText(text, len) {
			if (text.length <= len) {
				return text;
			}

			return `${text.slice(0, len)}...`;
		},
		formatNumber(number) {
			return number.toLocaleString('ko-KR');
		},
		isBannerIndex(index) {
			const BANNER_INDEX_IN_PAGE = 8;
			return index % this.pageSize === BANNER_INDEX_IN_PAGE;
		},
		getRecentArticlesState() {
			try {
				const {articles, scrollY} = JSON.parse(window.sessionStorage.getItem(this.stateStorageKey));

				return {
					articles: articles ?? [],
					scrollY: scrollY ?? 0
				}
			} catch {
				return {
					articles: [],
					scrollY: 0,
				}
			}
		},
		setRecentArticlesState() {
			window.sessionStorage.setItem(this.stateStorageKey, JSON.stringify({
				articles: this.articles,
				scrollY: window.scrollY,
			}));
		},
		goToArticle(article) {
			this.setRecentArticlesState();
			window.location.assign(this.makeArticleLinkUrl(article));
		},
		goToComment(article) {
			this.setRecentArticlesState();
			window.location.assign(this.makeArticleCommentLinkUrl(article));
		},
		unescapeBackslash(str) {
			return str.replace(/&#92;/g, '\\');
		},
		async loadAfterArticles() {
			if (!this.hasMore) {
				return;
			}

			this.loading = true;
			try {
				const {data} = await axios.get('/api/v1/recent-articles', {
					params: {
						grpid: this.grpId,
						pageSize: this.pageSize,
						afterFldId: this.afterFldId,
						afterDataId: this.afterDataId,
						afterRegDt: this.afterRegDt,
					}
				});

				if (data.articles.length === 0) {
					this.hasMore = false;
					return;
				}

				this.articles = [...this.articles, ...data.articles];
			} catch {
			} finally {
				this.loading = false;
			}
		}
	},
	async created() {
		const {articles, scrollY} = this.getRecentArticlesState();
		window.sessionStorage.removeItem(this.stateStorageKey);

		if (articles.length > 0) {
			this.articles = [...articles];
		}

		await this.$nextTick();
		if (scrollY) {
			window.scrollTo(0, scrollY);
		}
	},
	mounted() {
		const observer = new IntersectionObserver(([entry]) => {
			if (this.articles.length > 0 && !this.loading && entry.isIntersecting) {
				this.loadAfterArticles();
			}
		}, {
			rootMargin: '0px 0px 400px 0px'
		});

		observer.observe(this.$refs.bottomEl);
	}
}
</script>
